export function setHasViewedAllowlistNotice(bool: boolean) {
  if (bool) localStorage.setItem('hasViewedAllowlistNotice', 'true')
  else localStorage.removeItem('hasViewedAllowlistNotice')
}
